import React from "react";
import "aos/dist/aos.css";
import AOS from "aos";

const achievementsData = [
    {
        title: "Quick Draw",
        description: "Pull request within 24 hours.",
        date: "August 2023",
        badge: "https://github.githubassets.com/images/modules/profile/achievements/quickdraw-default.png",
    },
    {
        title: "30 JavaScript",
        description: "Completed 30 days of JavaScript",
        date: "September 2023",
        badge: "https://assets.leetcode.com/static_assets/others/%E9%9D%99%E6%80%81%E5%9B%BE.png",
    },
    {
        title: "PullShark",
        description: "Active pull request contributions.",
        date: "October 2023",
        badge: "https://github.githubassets.com/images/modules/profile/achievements/pull-shark-default.png",
    },
    {
        title: "Cisco Ethical Hacker",
        description: "Cybersecurity certification",
        date: "November 2023",
        badge: `${process.env.PUBLIC_URL}/media/badges/cisco-hacker.png`,
    }
    


];

const Achievementss = () => {
    React.useEffect(() => {
        AOS.init();
    }, []);

    const largeScreenAosDuration = "1000"; // AOS duration for large screens
    const smallScreenAosDuration = "800"; // AOS duration for small screens

    return (
        <>
            <div className="ubuntu-regular">
                {/* Small screen: Use only zoom-in AOS effect */}
                <div className="container mx-auto  rounded-lg p-4 shadow lg:hidden md:hidden">
                    <h2 className="text-3xl font-bold text-left p-4">
                        Achievements
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        {achievementsData.map((achievement, index) => (
                            <div
                                key={index}
                                className=" p-4 rounded-lg shadow-lg flex flex-row justify-center items-center gap-4"
                                data-aos="zoom-in" // Use zoom-in for small screens
                                data-aos-duration={smallScreenAosDuration} // Apply small screen AOS duration
                            >
                                <img
                                    src={achievement.badge}
                                    alt={achievement.title}
                                    className="w-16 h-16"
                                />
                                <div>
                                    <h3 className="text-xl font-semibold">
                                        {achievement.title}
                                    </h3>
                                    <p className="">
                                        {achievement.description}
                                    </p>
                                    <p className="text-sm">
                                        {achievement.date}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Large screen: Maintain individual AOS effects */}
                <div className="container mx-auto my-8 rounded-lg p-4 shadow hidden lg:block md:block">
                    <h2 className="text-2xl sm:text-3xl font-bold mb-6">
                        Achievements
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        {achievementsData.map((achievement, index) => (
                            <div
                                key={index}
                                className=" p-4 rounded-lg shadow-lg flex flex-row justify-center items-center gap-4"
                                data-aos="fade-up" // Keep fade-up for large screens
                                data-aos-duration={largeScreenAosDuration} // Apply large screen AOS duration
                            >
                                <img
                                    src={achievement.badge}
                                    alt={achievement.title}
                                    className="w-16 h-16"
                                    data-aos="zoom-in-right" // Individual effect
                                    data-aos-duration={largeScreenAosDuration}
                                />
                                <div
                                    data-aos="zoom-in-left"
                                    data-aos-duration={largeScreenAosDuration}
                                >
                                    <h3
                                        className="text-xl font-semibold"
                                        data-aos="zoom-down-right"
                                        data-aos-duration={
                                            largeScreenAosDuration
                                        }
                                    >
                                        {achievement.title}
                                    </h3>
                                    <p className="opacity-80">
                                        {achievement.description}
                                    </p>
                                    <p className="text-sm opacity-60">
                                        {achievement.date}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Achievementss;
